const a = {
  "roche-add-to-calendar": "roche-add-to-calendar"
};
export {
  a as default
};
